import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.app-empty-state {
  box-sizing: border-box;
  width: 100%;
  padding: ${dt('appEmptyState.padding')};
  background: ${dt('appEmptyState.background')};
  border: 1px solid ${dt('appEmptyState.borderColor')};
}

.app-empty-state .icon-wrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${dt('appEmptyState.iconWrap.size')};
  height: ${dt('appEmptyState.iconWrap.size')};
  padding: ${dt('appEmptyState.iconWrap.padding')};
  border-radius: ${dt('appEmptyState.iconWrap.borderRadius')};
  background: ${dt('appEmptyState.iconWrap.background')};
  color: ${dt('appEmptyState.iconWrap.color')};
  flex-shrink: 0;
}

.app-empty-state .icon-wrap .icon {
  font-size: ${dt('appEmptyState.iconGlyph.fontSize')};
  line-height: 1;
}

.app-empty-state .title {
  margin: 0;
  color: ${dt('appEmptyState.title.color')};
  font-size: ${dt('appEmptyState.title.fontSize')};
  font-weight: ${dt('appEmptyState.title.fontWeight')};
  line-height: ${dt('appEmptyState.title.lineHeight')};
  letter-spacing: 0;
  word-break: break-word;
}

.app-empty-state .description {
  margin: 0;
  color: ${dt('appEmptyState.description.color')};
  font-size: ${dt('appEmptyState.description.fontSize')};
  font-weight: ${dt('appEmptyState.description.fontWeight')};
  line-height: ${dt('appEmptyState.description.lineHeight')};
  letter-spacing: 0;
  word-break: break-word;
}
`;
